document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.custom-product-tab');
  const contents = document.querySelectorAll('.custom-product-tabs-desc');
  function deactivateAll() {
    tabs.forEach(tab => tab.classList.remove('active'));
    contents.forEach(content => content.style.display = 'none');
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      deactivateAll();
      tab.classList.add('active');
      if (contents[index]) {
        contents[index].style.display = 'block';
      }
    });
  });
  if (tabs.length && contents.length) {
    tabs[0].classList.add('active');
    contents[0].style.display = 'block';
  }
});

/*********************************************************/


  document.addEventListener("DOMContentLoaded", function () {
    const productGrid = document.getElementById("product-grid");
    const gridViewBtn = document.getElementById("custom-product-view-grid");
    const listViewBtn = document.getElementById("custom-product-view-list");

    // Apply saved view or default to grid
    const savedView = localStorage.getItem("productView") || "grid";
    if (productGrid) {
      
    
    productGrid.classList.add(savedView + "-view");
}
    // Helper function to switch view
    function switchView(view) {
      productGrid.classList.remove("grid-view", "list-view");
      productGrid.classList.add(view + "-view");
      localStorage.setItem("productView", view);
    }

    // Event listeners
    gridViewBtn.addEventListener("click", function () {
      switchView("grid");
    });

    listViewBtn.addEventListener("click", function () {
      switchView("list");
    });
  });

/***********************************************************************/
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });


